import { ComponentAPI } from '@philips-emr/tws-core';

export interface Data {
  [key: string]: object | string | number | boolean;
}

class RepeaterAPI extends ComponentAPI {

  getData(): Data[] {
    return this.state.data;
  }

  setData(data: Data[]): void {
    this.setState({ data });
  }

}

export default RepeaterAPI;
